import { useTranslation } from 'react-i18next';
import { CompactNumber } from '../typography/compact-number.tsx';
import { Button } from '../ui/button.tsx';
import SmallSpinner from '../ui/small-spinner.tsx';
import type { VerticalFilterViewState } from './types/vertical-filter-view-state.ts';

export type VerticalFiltersFooterProps = {
    state: VerticalFilterViewState;
    hasActiveFilters: boolean;
    onClearAll: () => void;
    onSaveView: () => void;
    onApplyFilters: () => void;
    itemCount?: number;
    isLoading: boolean;
    isFormValid?: boolean;
};

export function VerticalFiltersFooter({
    state,
    hasActiveFilters,
    onClearAll,
    onSaveView,
    onApplyFilters,
    itemCount,
    isLoading,
    isFormValid = true,
}: VerticalFiltersFooterProps) {
    const { t } = useTranslation();

    switch (state) {
        case 'save-view':
        case 'edit-view':
            return (
                <div className="flex shrink-0 grow-0 flex-row items-center justify-end space-x-3 border-t border-neutral-200 px-3 py-3">
                    <Button variant="subtle" onClick={onClearAll}>
                        {t('save_view_dialog__cancel', { ns: 'filters' })}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={onSaveView}
                        disabled={!isFormValid || !hasActiveFilters}
                    >
                        {state === 'edit-view'
                            ? t('edit_view_dialog__update', { ns: 'filters' })
                            : t('save_view_dialog__save', { ns: 'filters' })}
                    </Button>
                </div>
            );

        default:
            return (
                <div className="flex shrink-0 grow-0 flex-row items-center justify-end space-x-3 border-t border-neutral-200 px-3 py-3">
                    <Button variant="subtle" onClick={onClearAll}>
                        {t('form__cancel')}
                    </Button>
                    <Button variant="primary" onClick={onApplyFilters}>
                        {`${t('show_results')} `}
                        {isLoading && <SmallSpinner color="white" className="stroke-white" />}
                        {!isLoading && typeof itemCount === 'number' && (
                            <CompactNumber>{itemCount}</CompactNumber>
                        )}
                    </Button>
                </div>
            );
    }
}
